module.exports = __webpack_public_path__ + "static/img/1.bede3719.jpg";